import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-left",
  "use": "arrow-left-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" class=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"#000000\" id=\"arrow-left\"><g id=\"arrow-left_SVGRepo_bgCarrier\" stroke-width=\"0\"></g><g id=\"arrow-left_SVGRepo_tracerCarrier\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></g><g id=\"arrow-left_SVGRepo_iconCarrier\"><path d=\"M768 903.232l-50.432 56.768L256 512l461.568-448 50.432 56.768L364.928 512z\" fill=\"#000000\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol